import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/downloads/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

export const hasSourceDownloads = (textValue: string, state: State) =>
  fetchWithParamValidation(
    ({ value }) => getFromHamsClient(`/product/${value}/hasSourceDownloads`, state),
    {
      value: textValue,
    },
  );
